module.exports = __webpack_public_path__ + "static/media/test2.bb157dc6.png";